<template>
  <div class="animated fadeIn list-of-tranbank">
    <b-card>
      <div slot="header">
        Sales Order History by Customer
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>
            Export
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row>
        <b-col lg="4">
          <b-input-group>
            <b-input-group-prepend>
              <label>Customer Code</label>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="cust_info"
              placeholder="Enter Customer ..."
              @keyup.13.native="lkuCustShow=true"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuCustShow=true" variant="primary">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col lg="4">
          <b-input-group>
            <b-input-group-prepend>
              <span class="pt-2 mr-2">Trx. Date</span>
            </b-input-group-prepend>
            <b-form-input v-model="model.tgl1" type="date"></b-form-input>
            <b-input-group-prepend>
              <span class="input-group-text">-</span>
            </b-input-group-prepend>
            <b-form-input v-model="model.tgl2" type="date"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="2">
          <b-button class="btn btn-success" @click="getData()">
            <i class="fa fa-play"></i> Process
          </b-button>
        </b-col>
      </b-row>
      <b-card no-body>
        <b-row v-if="(filterShow=='Hide')">
          <b-col lg="4">
            <b-form-group
              label="Filter"
              label-cols-sm="1"
              label-size="sm"
              label-for="filterInput"
              class="mb-0"
            >
              <b-input-group size="sm">
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="5">
            <b-form-group
              label="Filter On"
              label-cols-sm="1"
              label-size="sm"
              description="Leave all unchecked to filter on all data"
              class="mb-0"
            >
              <b-form-checkbox-group v-model="filterOn" class="mt-1">
                <b-form-checkbox value="custinfo">Customer</b-form-checkbox>
                <b-form-checkbox value="uraian">Description</b-form-checkbox>
                <b-form-checkbox value="nomor">Sales Order No.</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
          <b-col lg="3">
            <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
              <b>{{ filterShow }}</b> Filter
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-table
          class="mb-0"
          ref="tableOri"
          sticky-header="600px"
          outlined
          responsive
          striped
          hover
          style="font-size:smaller;"
          :items="rptLines"
          :fields="tblLcy.fields"
          :current-page="tblLcy.page"
          :per-page="tblLcy.limit"
          :sort-by.sync="tblLcy.sortBy"
          :sort-desc.sync="tblLcy.sortDesc"
          :filter="filter"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"
        >
          <template v-slot:cell(OrderDate)="data">{{ data.item.OrderDate | moment("D-MMM-YY") }}</template>
          <template v-slot:cell(ttlamtdue)="data">{{ data.item.ttlamtdue | numFormat }}</template>
          <template v-slot:head(nilaibuku)="data">{{uanguser}} {{ data.item.nilaibuku | numFormat }}</template>
        </b-table>
        <b-row class="mt-2">
          <b-col cols="4">
            <div style="font-weight: bold;" class="ml-1">
              Total Sales Order : {{uanguser}}
              <div
                style="text-align:right; border:1px solid silver; width:200px;height:40px;border-top: 1px solid #000 ;border-bottom: 2px solid #000; background: #e6e6e6; display:inline;"
                class="pl-2 pt-2 pr-2"
              >{{subtotal.totalModul | numFormat('0,0.00')}}</div>
            </div>
          </b-col>
          <b-col cols="8">
            <b-row>
              <b-col cols="6" style="text-align:center">
                <div>
                  Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                  to
                  <span
                    v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)"
                  >{{tblLcy.total}}</span>
                  <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                  of {{tblLcy.total}} entries,
                  <span
                    class="ml-3 mr-1"
                  >limit per page :</span>
                  <select v-model="tblLcy.limit" style="width:60px;">
                    <option>10</option>
                    <option>15</option>
                    <option>20</option>
                    <option>25</option>
                    <option>30</option>
                  </select>
                </div>
                <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                  <b>{{ filterShow }}</b> Filter
                </b-form-checkbox>
              </b-col>
              <b-col cols="6">
                <b-pagination
                  align="right"
                  :total-rows="tblLcy.total"
                  :per-page="tblLcy.limit"
                  v-model="tblLcy.page"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="lkuCustShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
      <lku-cust @click="onSelectLkuCust"></lku-cust>
    </b-modal>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
.report-wraper {
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;

  table {
    font-size: smaller;
    th {
      border-bottom: 1px solid #d1d1d1;
      padding: 0 15px;
      height: 30px;
      background: #e8e8e8;
    }
            tbody tr:hover {
                background-color: rgba(91,192,222, 0.2) !important;
                cursor: default;
            }

    td {
      border-bottom: 1px solid #f5f5f5;
      padding: 0 10px;
      height: 25px;
    }

    tr.selisih {
      background: yellow;
    }

    td.tebal {
      font-weight: bold;
    }

    td.subtotal {
      border-top: 2px solid #000 !important;
    }

    td.total {
      border-top: 2px solid #000 !important;
      background: #e6e6e6 !important;
    }

    td.grdtotal {
      border-top: 2px solid #000 !important;
      border-bottom: 2px double #000 !important;
      background: #e6e6e6 !important;
    }
  }
}
iframe {
  border: 1px solid #ccc;
  width: 100%;
  height: 11in;
}
</style>

<script>
import moment from "moment";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

import salesorder from "../../apis/salesorder";
import lkuCust from "../lookup/lkuCustomer";

export default {
  mixins: [validationMixin],
  validations: {
    model: {
      tgl1: { required },
      tgl2: { required }
    }
  },
  data() {
    return {
      horizontal: true,
      isLoading: false,
      showReport: false,
      lkuCustShow: false,
      reportUrl: null,
      model: { account: "", tgl1: "", tgl2: "" },
      filterShow: "Show",
      uanguser: this.$store.state.user.matauang,
      accounts: [],
      rptLines: [],
      subtotal: {},
      tblLcy: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields: [
          {
            key: "nomor",
            label: "Sales Number",
            thStyle: "width:150px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "OrderDate",
            label: "Sales Order Date",
            thStyle: "width:150px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "custinfo",
            label: "Customer",
            sortable: true
          },
          {
            key: "description",
            label: "Description",
            sortable: true
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true
          },
          {
            key: "ttlamtdue",
            label: "Total Amt. Due",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          }
        ]
      },
      filter: null,
      filterOn: [],
      cust_info: null
    };
  },
  components: { Loading, lkuCust },
  computed: {
    invalidFilter() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  created: async function() {
    if (this.$route.params) {
      const params = this.$route.params;
      this.model.customer_id = params.customer_id;
      this.model.customer = params.cust_info;
      this.model.tgl1 = params.tgl1;
      this.model.tgl2 = params.tgl2;
      this.cust_info = params.cust_info;
      this.getData();
    } else {
      const tgl2 = moment(this.$store.state.user.tglaktif, "YYYY-MM-DD").endOf('month');
      this.model.tgl1 = this.$store.state.user.tglaktif;
      this.model.tgl2 = tgl2.format("YYYY-MM-DD");
    }
  },
  methods: {
    onSelectLkuCust(_selected) {
      this.cust_info = `${_selected.CustCode + " | " + _selected.CustName}`;
      this.model.customer_id = _selected.customer_id;
      this.model.customer = _selected.CustName;
      this.lkuCustShow = false;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
    },
    getData: async function(ctx) {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        this.model.sortDir = this.model.sortDesc ? "desc" : "asc";
        const result = await salesorder.list(this.model);
        this.rptLines = result;
        this.tblLcy.total = this.rptLines.length;
        this.subtotal.totalModul = result.reduce((a, b) => a + b.ttlamtdue, 0);
        this.isLoading = false;
      }
    },
    exportxls: async function() {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          const response = await salesorder.exportxls(this.model);
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    close() {
      router.push({name: "sales.home"});
    }
  }
};
</script>
